import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import hmacSHA256 from "crypto-js/hmac-sha256";
import openSocket from "socket.io-client";

// Import images
import FreeSeats from "../../assets/img/free-seats.png";
import SelectedSeats from "../../assets/img/selected-seats.png";
import TakenSeats from "../../assets/img/taken-seats.png";

// Import environment variables
import {
  corvusPaySignKey,
  corvusPayStoreId,
  corvusPayValuta,
  corvusPayVersion,
} from "../../utils/Environment";

// Import styled components
import {
  HeadliningContainer,
  FilmContainer,
  FilmHeadlining,
  Date,
  Time,
  TicketsNumber,
  BuyButton,
  Container,
  PriceContainer,
  PriceText,
  PurchaseNotice,
} from "./TicketsStyle";

// Import components
import Cinema from "../Cinema/Cinema";
import { Projections } from "../../models/Projections";
import { ProjectionsServices } from "../../services/ProjectionsServices";
import SellingPopup from "../SellingPopup/SellingPopup";
import { isProjectionPurchaseLocked } from "../../utils/projectionPurchase";

const Tickets = () => {
  const { projectionId } = useParams();
  const [name, setName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [error, setError] = useState<boolean>(false);
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const [selectedSeats, setSelectedSeats] = useState<number[]>([]);
  const [projection, setProjection] = useState<Projections>();
  const seats: number[][] = [
    [1, 9, 8, 7, 6, 5, 4, 3, 2, 0, 0, 0, 0],
    [37, 38, 39, 40, 41, 42, 43, 44, 45, 0, 0, 0, 0],
    [28, 29, 30, 31, 32, 33, 34, 35, 36, 0, 0, 0, 0],
    [19, 20, 21, 22, 23, 24, 25, 26, 27, 0, 0, 0, 0],
    [10, 11, 12, 13, 14, 15, 16, 17, 18, 0, 0, 0, 0],
    [46, 47, 48, 49, 50, 51, 52, 53, 54, 0, 0, 55, 56],
    [57, 58, 59, 60, 61, 62, 63, 64, 65, 0, 0, 66, 67],
    [68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 80, 79],
  ];

  const [seatsStatus, seatSeatsStatus] = useState<{
    [key: number]: string[];
  }>({
    1: [
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
    ],
    2: [
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
    ],
    3: [
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
    ],
    4: [
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
    ],
    5: [
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
    ],
    6: [
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      undefined,
      undefined,
      FreeSeats,
      FreeSeats,
    ],
    7: [
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      undefined,
      undefined,
      FreeSeats,
      FreeSeats,
    ],
    8: [
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
      FreeSeats,
    ],
  });

  const socket = openSocket("https://shark-app-xoiff.ondigitalocean.app");

  socket.on("posts", (data) => {
    if (data.action === "create") {
      let seatsArray: number[] = selectedSeats;
      for (const seat of data.newOccupiedSeat) {
        if (seat.projection == projectionId) {
          let row: number = 0;
          let columns: number = 0;
          for (const [index, seatId] of seats.entries()) {
            const column: number = seatId.findIndex(
              (item) => item === seat.seats,
            );
            if (column !== -1) {
              columns = column;
              row = index + 1;
              seatsArray.filter((seats) => seats !== seat.id);
            }
          }
          seatsStatus[row][columns] = TakenSeats;
          seatSeatsStatus({ ...seatsStatus });
        }
      }
      setSelectedSeats(seatsArray);
    }
  });

  socket.on("delete", (data) => {
    if (data.action === "delete") {
      if (data.deletedSeats.projectionId == projectionId) {
        let row: number = 0;
        let columns: number = 0;
        for (const [index, seatId] of seats.entries()) {
          const column: number = seatId.findIndex(
            (item) => item === data.deletedSeats.seats,
          );
          if (column !== -1) {
            columns = column;
            row = index + 1;
          }
        }
        seatsStatus[row][columns] = FreeSeats;
        seatSeatsStatus({ ...seatsStatus });
      }
    }
  });

  useEffect(() => {
    localStorage.clear();
    ProjectionsServices.getProjectionById(Number(projectionId!)).then(
      (projection: Projections) => {
        setProjection(projection);
      },
    );
  }, []);

  useEffect(() => {}, [selectedSeats]);

  const isPurchaseLocked =
    projection !== undefined &&
    isProjectionPurchaseLocked(projection.date, projection.time);

  const handleClick = async () => {
    if (projection === undefined || isPurchaseLocked) {
      alert("Kupnja je zatvorena manje od 3 sata prije projekcije.");
      return;
    }

    if (name === "") {
      setError(true);
      return;
    }
    if (lastName === "") {
      setError(true);
      return;
    }
    if (!email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
      setError(true);
      return;
    }
    setError(false);

    const isSeatsAvailable = await ProjectionsServices.checkIfSeatsAreAvailable(
      projection!.id,
      selectedSeats,
    );

    if (!isSeatsAvailable) {
      alert(
        "Neki od odabranih sjedala su zauzeti. Molimo odaberite druga sjedala.",
      );
      window.location.reload();
      return;
    }

    // add seats to database before go to payment
    const buyedSeats = await ProjectionsServices.addOccupiedSeatsToProjection(
      projection!,
      name,
      lastName,
      email,
      selectedSeats,
    );

    const form = document.createElement("form");
    form.method = "POST";
    form.action = `https://shark-app-xoiff.ondigitalocean.app/checkout`;
    form.enctype = "application/json";

    // Dodaj podatke u formu
    const buySeatsInput = document.createElement("input");
    buySeatsInput.type = "hidden";
    buySeatsInput.name = "buyedSeats";
    buySeatsInput.value = JSON.stringify(buyedSeats);
    form.appendChild(buySeatsInput);

    const projectionInput = document.createElement("input");
    projectionInput.type = "hidden";
    projectionInput.name = "projection";
    projectionInput.value = JSON.stringify(projection);
    form.appendChild(projectionInput);

    document.body.appendChild(form);
    form.submit();
  };

  return (
    <>
      {projection === undefined ? (
        <></>
      ) : (
        <>
          <HeadliningContainer>
            <FilmContainer>
              <FilmHeadlining>{projection?.moviename}</FilmHeadlining>
              <Date>
                Datum:{" "}
                {projection?.date
                  .toString()
                  .split("T")[0]
                  .split("-")
                  .reverse()
                  .join(".")}
                {"."}
              </Date>
              <Time>
                Vrijeme: {projection?.time.toString().substring(0, 5)}h
              </Time>
            </FilmContainer>
            <TicketsNumber>
              Broj Ulaznica <hr></hr> <b>{selectedSeats.length}</b>
            </TicketsNumber>
            <BuyButton
              $isDisabled={isPurchaseLocked}
              disabled={isPurchaseLocked}
              onClick={() => {
                if (!isPurchaseLocked && selectedSeats.length !== 0) {
                  setOpenPopup(true);
                }
              }}
            >
              Kupi
            </BuyButton>
          </HeadliningContainer>
          {isPurchaseLocked ? (
            <>
              <PurchaseNotice>
                Kupnja online nije dostupna manje od 3 sata prije projekcije.
              </PurchaseNotice>
              <PurchaseNotice>
                Preostale ulaznice mogu se kupiti na blagajni kina.
              </PurchaseNotice>
            </>
          ) : null}
          <Container>Odabir ulaznica</Container>
          <Cinema
            projectionId={Number(projectionId!)}
            setSelectedSeats={setSelectedSeats}
            selectedSeats={selectedSeats}
            seatSeatsStatus={seatSeatsStatus}
            seatsStatus={seatsStatus}
            seats={seats}
            isPurchaseLocked={isPurchaseLocked}
          />
          <PriceContainer>
            <PriceText>Broj ulaznica: {selectedSeats.length} </PriceText>
            <PriceText>
              Ukupna cijena: {selectedSeats.length * projection?.price!} €
            </PriceText>
          </PriceContainer>
          <SellingPopup
            projection={projection!}
            numberOfTickets={selectedSeats.length}
            setName={setName}
            setLastName={setLastName}
            setEmail={setEmail}
            handleClick={handleClick}
            error={error}
            isOpen={openPopup}
            setOpenPopup={setOpenPopup}
          />
        </>
      )}
    </>
  );
};

export default Tickets;
